module.exports = __webpack_public_path__ + "img/logo.cf809042.svg";